export enum GeometryShape {
  MULTI_POLYGON = 'MultiPolygon',
  POLYGON = 'Polygon',
  POINT = 'Point',
}
